/*
 * Doto x Searchanise — Fake original price
 * Mirrors the PDP logic in product-price-with-fake.liquid:
 *   fake/original price = current price x 1.12
 *
 * Scope: Searchanise Search Results / Smart Navigation product cards.
 */

const DOTO_SEARCHANISE_FAKE_PRICE_MULTIPLIER = 1.12;
const DOTO_SEARCHANISE_RESULTS_SELECTOR = '#snize_results, .snize-search-results';
const DOTO_SEARCHANISE_CARD_SELECTOR = '.snize-product';
const DOTO_SEARCHANISE_PRICE_SELECTOR = '.snize-price-list .snize-price, .snize-price';
const DOTO_SEARCHANISE_FAKE_CLASS = 'doto-searchanise-fake-price';
const DOTO_SEARCHANISE_SHIPPING_CLASS = 'doto-searchanise-free-shipping';
const DOTO_SEARCHANISE_CASHBACK_CLASS = 'doto-searchanise-cashback';
const DOTO_SEARCHANISE_DOTOCASH_ICON = 'data:image/png;base64,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';

const dotoSearchaniseMoneyFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

function dotoParseSearchaniseMoney(value) {
  if (!value) return null;

  const compact = String(value)
    .replace(/\s/g, '')
    .replace(/[^\d.,-]/g, '');

  if (!compact) return null;

  const lastDot = compact.lastIndexOf('.');
  const lastComma = compact.lastIndexOf(',');
  let normalized = compact;

  // Supports both 5,619.00 and 5.619,00 formats.
  if (lastDot > -1 && lastComma > -1) {
    if (lastDot > lastComma) {
      normalized = compact.replace(/,/g, '');
    } else {
      normalized = compact.replace(/\./g, '').replace(',', '.');
    }
  } else if (lastDot > -1) {
    const decimalLength = compact.length - lastDot - 1;
    normalized = decimalLength > 0 && decimalLength <= 2
      ? compact.replace(/,/g, '')
      : compact.replace(/\./g, '');
  } else if (lastComma > -1) {
    const decimalLength = compact.length - lastComma - 1;
    normalized = decimalLength > 0 && decimalLength <= 2
      ? compact.replace(/\./g, '').replace(',', '.')
      : compact.replace(/,/g, '');
  }

  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

function dotoGetSearchaniseCurrentPriceElement(card) {
  const candidates = Array.from(card.querySelectorAll(DOTO_SEARCHANISE_PRICE_SELECTOR))
    .filter((element) => !element.classList.contains(DOTO_SEARCHANISE_FAKE_CLASS));

  if (!candidates.length) return null;

  // Searchanise marks the discounted/current price with this class when applicable.
  const discountedPrice = candidates.find((element) =>
    element.classList.contains('snize-price-with-discount')
  );

  if (discountedPrice) return discountedPrice;

  // Otherwise prefer the visible non-crossed-out price if more than one exists.
  const visibleCurrentPrice = candidates.find((element) => {
    const styles = window.getComputedStyle(element);
    const decoration = `${styles.textDecorationLine} ${styles.textDecoration}`;
    return styles.display !== 'none'
      && styles.visibility !== 'hidden'
      && !decoration.includes('line-through');
  });

  return visibleCurrentPrice || candidates[0];
}

function dotoApplySearchaniseFakePrice(card) {
  const currentPriceElement = dotoGetSearchaniseCurrentPriceElement(card);
  if (!currentPriceElement) return;

  const currentPrice = dotoParseSearchaniseMoney(currentPriceElement.textContent);
  if (!currentPrice || currentPrice <= 0) return;

  const priceList = currentPriceElement.closest('.snize-price-list') || currentPriceElement.parentElement;
  if (!priceList) return;

  const fakePrice = currentPrice * DOTO_SEARCHANISE_FAKE_PRICE_MULTIPLIER;
  const formattedFakePrice = dotoSearchaniseMoneyFormatter.format(fakePrice);

  let fakePriceElement = card.querySelector(`.${DOTO_SEARCHANISE_FAKE_CLASS}`);

  if (!fakePriceElement) {
    fakePriceElement = document.createElement('span');
    fakePriceElement.className = DOTO_SEARCHANISE_FAKE_CLASS;
    fakePriceElement.setAttribute('data-doto-searchanise-fake-price', 'true');
    currentPriceElement.insertAdjacentElement('afterend', fakePriceElement);
  } else if (fakePriceElement.parentElement !== priceList) {
    currentPriceElement.insertAdjacentElement('afterend', fakePriceElement);
  }

  if (fakePriceElement.textContent !== formattedFakePrice) {
    fakePriceElement.textContent = formattedFakePrice;
  }

  fakePriceElement.dataset.dotoCurrentPrice = currentPrice.toFixed(2);
  fakePriceElement.dataset.dotoMultiplier = String(DOTO_SEARCHANISE_FAKE_PRICE_MULTIPLIER);
}

function dotoApplySearchaniseCashback(card) {
  const currentPriceElement = dotoGetSearchaniseCurrentPriceElement(card);
  if (!currentPriceElement) return;

  const currentPrice = dotoParseSearchaniseMoney(currentPriceElement.textContent);
  if (!currentPrice || currentPrice <= 0) return;

  const priceList = currentPriceElement.closest('.snize-price-list') || currentPriceElement.parentElement;
  if (!priceList) return;

  const amount = Math.round(currentPrice * 0.01);
  if (!amount) return;

  let cashback = card.querySelector(`.${DOTO_SEARCHANISE_CASHBACK_CLASS}`);
  if (!cashback) {
    cashback = document.createElement('span');
    cashback.className = `${DOTO_SEARCHANISE_CASHBACK_CLASS} doto-card-cashback`;
    cashback.dataset.dotoCardCashback = 'true';
    cashback.dataset.dotoCashbackPercent = '1';
    cashback.title = 'Recibe 1% en DotoCash';
    cashback.innerHTML = `
      <img class="doto-card-cashback__icon" src="${DOTO_SEARCHANISE_DOTOCASH_ICON}" alt="" width="20" height="20" aria-hidden="true">
      <span class="doto-card-cashback__amount"></span>
      <span class="doto-card-cashback__label">en dotocash</span>
    `;
  }

  const amountEl = cashback.querySelector('.doto-card-cashback__amount');
  if (amountEl) amountEl.textContent = `$${amount.toLocaleString('en-US')}`;
  cashback.setAttribute('aria-label', `Recibe $${amount.toLocaleString('en-US')} en DotoCash`);

  if (cashback.previousElementSibling !== priceList) {
    priceList.insertAdjacentElement('afterend', cashback);
  }
}

function dotoApplySearchaniseFreeShipping(card) {
  const priceList = card.querySelector('.snize-price-list');
  if (!priceList) return;

  let shippingElement = card.querySelector(`.${DOTO_SEARCHANISE_SHIPPING_CLASS}`);

  if (!shippingElement) {
    shippingElement = document.createElement('div');
    shippingElement.className = DOTO_SEARCHANISE_SHIPPING_CLASS;
    shippingElement.setAttribute('data-doto-searchanise-free-shipping', 'true');
    shippingElement.setAttribute('aria-label', 'Envío gratis');

    shippingElement.innerHTML = `
      <svg class="doto-searchanise-free-shipping__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M3 6.5h11v10H3z"></path>
        <path d="M14 10h3.5l3.5 3.5v3H14z"></path>
        <circle cx="7" cy="18" r="2"></circle>
        <circle cx="18" cy="18" r="2"></circle>
        <path d="M5 10h5"></path>
        <path d="M3 13h4"></path>
      </svg>
      <span class="doto-searchanise-free-shipping__text">ENVÍO GRATIS</span>
    `;
  }

  if (shippingElement.previousElementSibling !== priceList) {
    priceList.insertAdjacentElement('afterend', shippingElement);
  }
}



function dotoSetImportant(element, property, value) {
  if (!element?.style) return;
  const currentValue = element.style.getPropertyValue(property);
  const currentPriority = element.style.getPropertyPriority(property);
  if (currentValue === value && currentPriority === 'important') return;
  element.style.setProperty(property, value, 'important');
}

function dotoNormalizeCtaText(value) {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
}

function dotoFindSearchaniseMobileCta(card) {
  const textCandidates = Array.from(
    card.querySelectorAll('a, button, [role="button"], .snize-button, span, div')
  );

  const exactLabel = /^(VER(?:\s+PRODUCTO)?|VER\s*(?:\.{3}|…)|VIEW(?:\s+PRODUCT)?|ADD\s+TO\s+CART|AGREGAR|AÑADIR(?:\s+AL\s+CARRITO)?)$/i;

  // Find the smallest element whose visible label is the CTA text. This also
  // works if Searchanise changes the class name on mobile.
  const labelNode = textCandidates
    .filter((element) => {
      const text = dotoNormalizeCtaText(element.textContent);
      if (!exactLabel.test(text)) return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden';
    })
    .sort((a, b) => a.children.length - b.children.length)[0];

  if (labelNode) {
    const clickable = labelNode.closest('a, button, [role="button"], .snize-button');
    if (clickable && card.contains(clickable)) return clickable;
    return labelNode;
  }

  // Fallback to known Searchanise CTA classes.
  const classCandidates = Array.from(card.querySelectorAll([
    '.snize-button',
    '.snize-view-product-button',
    '.snize-add-to-cart-button',
    '[class*="snize"][class*="button"]'
  ].join(',')));

  return classCandidates.find((element) => {
    const text = dotoNormalizeCtaText(element.textContent);
    const style = window.getComputedStyle(element);
    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && (text.includes('VER') || text.includes('VIEW') || text.includes('AGREG') || text.includes('AÑAD'));
  }) || null;
}

function dotoForceSearchaniseMobileCta(card) {
  // Searchanise can switch to its mobile DOM before/after the theme breakpoint.
  // Scope by either actual mobile-design class or viewport width.
  const mobileRoot = card.closest('.snize-mobile-design');
  if (!mobileRoot && !window.matchMedia('(max-width: 991px)').matches) return;

  const button = dotoFindSearchaniseMobileCta(card);
  if (!button) return;

  button.setAttribute('data-doto-mobile-full-cta', 'true');

  // Fix the label even when Searchanise literally renders "VER ...".
  const labelText = dotoNormalizeCtaText(button.textContent);
  if (/^VER\s*(?:\.{3}|…)?$/i.test(labelText)) {
    const nestedLabel = Array.from(button.querySelectorAll('span, strong, em')).find((node) =>
      /^VER\s*(?:\.{3}|…)?$/i.test(dotoNormalizeCtaText(node.textContent))
    );
    if (nestedLabel) {
      nestedLabel.textContent = 'VER PRODUCTO';
    } else {
      button.textContent = 'VER PRODUCTO';
    }
  }

  const buttonStyles = {
    width: '100%',
    minWidth: '0px',
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1 100%',
    alignSelf: 'stretch',
    position: 'relative',
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto',
    inset: 'auto',
    transform: 'none',
    marginTop: '16px',
    marginRight: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    paddingTop: '0px',
    paddingRight: '8px',
    paddingBottom: '0px',
    paddingLeft: '8px',
    height: '44px',
    minHeight: '44px',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    overflow: 'visible',
    textOverflow: 'clip',
    float: 'none'
  };

  Object.entries(buttonStyles).forEach(([property, value]) => {
    const cssProperty = property.replace(/[A-Z]/g, (match) => '-' + match.toLowerCase());
    dotoSetImportant(button, cssProperty, value);
  });

  // The main blocker on some Searchanise mobile templates is NOT the button:
  // one or two wrapper elements are width:auto / inline-block. Stretch those too.
  let wrapper = button.parentElement;
  let level = 0;
  while (wrapper && wrapper !== card && level < 3) {
    wrapper.setAttribute('data-doto-mobile-cta-wrapper', String(level + 1));
    dotoSetImportant(wrapper, 'width', '100%');
    dotoSetImportant(wrapper, 'min-width', '0px');
    dotoSetImportant(wrapper, 'max-width', '100%');
    dotoSetImportant(wrapper, 'box-sizing', 'border-box');
    dotoSetImportant(wrapper, 'flex', '1 1 100%');
    dotoSetImportant(wrapper, 'align-self', 'stretch');
    dotoSetImportant(wrapper, 'float', 'none');
    dotoSetImportant(wrapper, 'margin-left', '0px');
    dotoSetImportant(wrapper, 'margin-right', '0px');
    wrapper = wrapper.parentElement;
    level += 1;
  }

  button.querySelectorAll('*').forEach((child) => {
    dotoSetImportant(child, 'max-width', 'none');
    dotoSetImportant(child, 'white-space', 'nowrap');
    dotoSetImportant(child, 'overflow', 'visible');
    dotoSetImportant(child, 'text-overflow', 'clip');
  });
}

function dotoRefreshSearchaniseFakePrices() {
  const roots = document.querySelectorAll(DOTO_SEARCHANISE_RESULTS_SELECTOR);
  if (!roots.length) return;

  roots.forEach((root) => {
    root.querySelectorAll(DOTO_SEARCHANISE_CARD_SELECTOR).forEach((card) => {
      dotoApplySearchaniseFakePrice(card);
      dotoApplySearchaniseFreeShipping(card);
      dotoApplySearchaniseCashback(card);
      dotoForceSearchaniseMobileCta(card);
    });
  });
}

let dotoSearchaniseRefreshScheduled = false;

function dotoScheduleSearchaniseFakePriceRefresh() {
  if (dotoSearchaniseRefreshScheduled) return;
  dotoSearchaniseRefreshScheduled = true;

  window.requestAnimationFrame(() => {
    dotoSearchaniseRefreshScheduled = false;
    dotoRefreshSearchaniseFakePrices();
  });
}

function dotoInitSearchaniseFakePrice() {
  dotoScheduleSearchaniseFakePriceRefresh();

  [80, 250, 700, 1500, 3000, 5000].forEach((delay) => {
    window.setTimeout(dotoScheduleSearchaniseFakePriceRefresh, delay);
  });

  const observer = new MutationObserver((mutations) => {
    const hasRelevantMutation = mutations.some((mutation) => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement;

      if (target?.closest?.(DOTO_SEARCHANISE_RESULTS_SELECTOR)) return true;

      return Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) return false;
        return node.matches(DOTO_SEARCHANISE_RESULTS_SELECTOR)
          || Boolean(node.querySelector(DOTO_SEARCHANISE_RESULTS_SELECTOR));
      });
    });

    if (hasRelevantMutation) {
      dotoScheduleSearchaniseFakePriceRefresh();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  // Searchanise recalculates mobile CTA geometry on viewport/layout changes.
  window.addEventListener('resize', dotoScheduleSearchaniseFakePriceRefresh, { passive: true });
  window.addEventListener('orientationchange', dotoScheduleSearchaniseFakePriceRefresh, { passive: true });
  document.addEventListener('Searchanise.Loaded', dotoScheduleSearchaniseFakePriceRefresh);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', dotoInitSearchaniseFakePrice, { once: true });
} else {
  dotoInitSearchaniseFakePrice();
}
